import classNames from 'classnames/bind';

import styles from './index.module.scss';
import LinkButton from '../linkButton';

const cx = classNames.bind(styles);

const Footer = () => {
  return (
    <footer className={cx('container')}>
      <h2 className={cx('title')}>LEVRAI COSMETICS</h2>
      <div className={cx('wrapper')}>
        <ul className={cx('info')}>
          <li>
            <a href="tel:82-70-8758-2022">82-70-8758-2022</a>
          </li>
          <li>
            <a href="https://www.instagram.com/levrai.official/" target="_blank" rel="noreferrer">
              @levrai.official
            </a>
          </li>
          <li>
            <a href="https://www.levraiofficial.com/" target="_blank" rel="noreferrer">
              www.levraiofficial.com
            </a>
          </li>
          <li>
            <a href="mailto:sora.kim@levraiofficial.com">sora.kim@levraiofficial.com</a>
          </li>
        </ul>
        <LinkButton title="CONTACT US" link="/about#contact" color="black" />
      </div>
      <p className={cx('copyright')}>
        <img src={require('../../asset/images/global/logo_white.png')} alt="LEVRAI" />© 2026
      </p>
    </footer>
  );
};

export default Footer;
